import { render } from "./BlViewHistory.vue?vue&type=template&id=2627d964&scoped=true"
import script from "./BlViewHistory.vue?vue&type=script&lang=js"
export * from "./BlViewHistory.vue?vue&type=script&lang=js"

import "./BlViewHistory.vue?vue&type=style&index=0&id=2627d964&scoped=true&lang=scss"

import exportComponent from "/tmp/eb47f32b-990a-42a6-a461-0a5e6cce3094/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2627d964"]])

export default __exports__